module.exports = __webpack_public_path__ + "static/media/experience-unified.97fd906b.svg";